import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { Button, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { EnergyInterfacesStore } from '../../stores/energy-interfaces.store';
import { EnergyInterfaceDetailsNav } from '../../components/energy-interface-details-nav/energy-interface-details-nav';
import { EnergyInterfaceDetailsBreadcrumbNav } from '../../components/energy-interface-details-breadcrumb-nav/energy-interface-details-breadcrumb-nav';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { NavSkeleton } from '../../../../shared/components/nav-skeleton/nav-skeleton';

@Component({
  selector: 'app-energy-interface-details-page',
  imports: [
    RouterLink,
    PageTitle,
    PageHeader,
    OrganizationSidebarLayout,
    Button,
    NgIcon,
    RouterOutlet,
    EnergyInterfaceDetailsNav,
    EnergyInterfaceDetailsBreadcrumbNav,
    ErrorPage,
    NavSkeleton,
    Skeleton,
  ],
  templateUrl: './energy-interface-details-page.html',
})
export class EnergyInterfaceDetailsPage {
  private store = inject(EnergyInterfacesStore);
  protected router = inject(Router);

  organizationId = input.required<string>();
  energyInterfaceId = input.required<string>();

  state = computed(() =>
    this.store.energyInterfaces()?.find((ei) => ei.id === this.energyInterfaceId()),
  );
}
